export const initialSharedState = {
  data: [],
  loading: false,
  error: "",
};
